import { businessDate, toYearMonth, type YearMonth } from '@financial/shared';

/** Mes vigente según la zona de negocio compartida con la API y el cron. */
export function currentYearMonth(now = new Date()): YearMonth {
  return toYearMonth(now);
}

/** Fecha de calendario vigente en la zona de negocio, sin depender del navegador. */
export function currentBusinessDateParts(now = new Date()): {
  year: number;
  month: number;
  day: number;
} {
  const normalized = businessDate(now);
  return {
    year: normalized.getUTCFullYear(),
    month: normalized.getUTCMonth() + 1,
    day: normalized.getUTCDate(),
  };
}
